import React, { Fragment, useState, useEffect } from "react";
import ReactCardFlip from "react-card-flip";
import Fade from "react-reveal/Fade";
import { ManagementTeam, SalaamDirectors } from "../../Data/Data";
import AOS from "aos";
import "aos/dist/aos.css";

function Directorbox() {
  const [isFlipped, setIsFlipped] = useState(
    Array(SalaamDirectors.length).fill(false)
  );

  const handleClick = (index) => {
    setIsFlipped((prevState) => {
      const newFlipped = [...prevState];
      newFlipped[index] = !newFlipped[index];
      return newFlipped;
    });
  };

  useEffect(() => {
    AOS.refresh();
  }, [isFlipped]);

  return (
    <Fragment>
   
      <div>
        <h2 data-aos="fade-right" data-aos-duration="4000">
        Management Team
        </h2>
      </div>
      <div className="container governanceData management-grid">
        <div className="management-row" style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '22px', alignItems: 'stretch'}}>
          {ManagementTeam.map((data, index) => (
            <div key={index} className="management-card" style={{flex: '0 0 calc(33.333% - 24px)', maxWidth: 'calc(33.333% - 24px)', boxSizing: 'border-box'}}>
              <Fade down delay={500}>
                <ReactCardFlip
                  isFlipped={isFlipped[index]}
                  flipDirection={data.animation}
                  containerStyle={{ height: "100%" }}
                >
                  <div>
<button onClick={() => handleClick(index)} className="management-button" style={{display: 'block', padding: 0, border: 'none', background: 'transparent', textAlign: 'left'}}>
                      <img className="management-img" src={data.image} alt="directors" style={{width: '100%', objectFit: 'cover', display: 'block', borderRadius: 4}} />
                      <div className="card-content" style={{padding: '10px 12px 0'}}>
                        <h3 className="dname" style={{textAlign: 'center', fontSize: 20, margin: '8px 0 4px', color: '#0e76bc'}}>{data.name}</h3>
                        <p className="designation" style={{textAlign: 'center', paddingLeft: 17, width: '100%', fontSize: 16, color: '#4b4b4b', margin: 0}}>{data.designation}</p>
                      </div>
                    </button>
                  </div>

                  <div>
                    <button
                      onClick={() => handleClick(index)}
                      className="backbox"
                      style={{backgroundColor: '#0fb583', border: 'unset', overflowY: 'auto', padding: '12px', color: '#fff'}}
                    >
                      <Fade left>
                          <p style={{margin:0}}>
                            {data.detail}
                          </p>
                        </Fade>
                      {data?.detail1 && (
                        <Fade left>
                          <p style={{margin:0}}>
                            {data.detail1}
                          </p>
                        </Fade>
                      )}
                      {data?.detail2 && (
                        <Fade left>
                        <p style={{margin:0}}>
                          {data.detail2}
                        </p>
                      </Fade>
                      )}

                      {data?.detail3 && (
                        <Fade left>
                        <p style={{margin:0}}>
                          {data.detail3}
                        </p>
                      </Fade>
                      )}

                      {data?.detail4 && (
                        <Fade left>
                        <p style={{margin:0}}>
                          {data.detail4}
                        </p>
                      </Fade>
                      )}

                      {data?.detail5 && (
                        <Fade left>
                        <p style={{margin:0}}>
                          {data.detail5}
                        </p>
                      </Fade>
                      )}

                      {data?.detail6 && (
                        <Fade left>
                        <p style={{margin:0}}>
                          {data.detail6}
                        </p>
                      </Fade>
                      )}
                    </button>
                  </div>
                </ReactCardFlip>
              </Fade>
            </div>
          ))}
        </div>
      </div>
    </Fragment>
  );
}

export default Directorbox;
